import { useVisualContext } from "Contexts/VisualContext";
// import { motion } from "framer-motion";
// import { useMinWidthBreakpoint } from "Hooks/useBreakpoint";
// import { Link } from "react-router-dom";
import styles from "Styles/Pagination.module.css";
// import useDelayedNavigate from "Hooks/useDelayedNavigate";

const PaginationBar = ({
  currentPage = "",
  navigationData = [], // an array containing objects with page slugs and indexes. provided in NavigationWrapper via progress context.
  progress = [], // an array containing boolean values of whether each page in the form is complete.
}) => {
  const { backgroundStyle } = useVisualContext();

  const getProgressWidthPercent = (progressArray) => {
    const completeCount = progressArray.filter((item) => item).length;
    const width = (completeCount / progressArray.length) * 100;

    return `${width}%`;
  };

  // const { delayedNavigate } = useDelayedNavigate();

  const wrapperClassName = `${styles.paginationWrapper}${backgroundStyle === "inverted" ? ` ${styles["pagination-inverted"]}` : ""}`;

  return (
    <div className={styles.paginationContainer}>
      <div className={wrapperClassName}>
        <>
          {navigationData.map((page, index) => {
            const isActive = page.slug === currentPage;
            return (
              // <Link
              //   key={index}
              //   to={`/form/${page.slug}`}
              //   onClick={(e) => {
              //     e.preventDefault();
              //     delayedNavigate(`/form/${page.slug}`, 250);
              //   }}
              //   style={{
              //     opacity: progress[index] ? 1 : 0.4,
              //     pointerEvents: progress[index] ? "auto" : "none",
              //   }}
              // >
              //   {index + 1}
              // </Link>
              <span
                key={index}
                className={`${styles.paginationLink}${isActive ? ` ${styles.paginationLinkActive}` : ""}`}
                style={{ opacity: progress[index] ? 1 : 0.4 }}
              >
                {page.navigationIndex}
                {isActive && <span className={styles.paginationRing} />}
              </span>
            );
          })}
        </>
      </div>
      <div className={styles.paginationProgress}>
        <div
          className={styles.paginationProgressBar}
          style={{ width: getProgressWidthPercent(progress) }}
        ></div>
      </div>
    </div>
  );
};

export default PaginationBar;
